import ButtonMenu from '@/components/ButtonMenu/index.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import LogScaleRange from "@/components/LogScaleRange.vue"
import { env } from '@/env'
import ModuleOutlet from "@/modules/ModuleOutlet.vue"
import * as VueStellarGlobe from '@/stellar-globe-components'
import { store } from '@/store'
import { id } from '@/utils/id'
import * as VueMenu from '@hscmap/vue-menu'
import * as VueWindow from '@hscmap/vue-window'
import Vue from 'vue'
import RangeSlider from 'vue-range-slider'
import VueRouter from 'vue-router'
//  @ts-ignore
import draggable from 'vuedraggable'

function setup() {
  Vue.use(VueRouter)
  Vue.use(VueMenu, { prefix: 'menu' })
  Vue.use(VueWindow, { prefix: 'window' })
  Vue.use(VueStellarGlobe, { prefix: 'v' })
  Vue.component('log-scale-range', LogScaleRange)
  Vue.component('color-picker', ColorPicker)
  Vue.component('button-menu', ButtonMenu)
  Vue.component('draggable', draggable)
  Vue.component('ModuleOutlet', ModuleOutlet)
  Vue.component('range-slider', RangeSlider)

  Vue.mixin({
    methods: {
      Id(o: any) {
        return id(o)
      },
    },
    computed: {
      Store: () => store,
      Env: () => env,
    },
  })
}

export const vue = {
  setup,
}
